package fr.arcplex.network.http

import kotlinx.serialization.json.*

class JsonMap(private val data: Any?) {
    fun get(key: String): JsonMap? {
        val value = when (data) {
            is Map<*, *> -> data[key]
            is JsonObject -> data[key]
            else -> null
        }
        return if (value == null) null else JsonMap(value)
    }

    fun getString(key: String): String? {
        val value = when (data) {
            is Map<*, *> -> data[key]
            is JsonObject -> data[key]
            else -> null
        }
        return if (value is JsonPrimitive) value.content else (value as? String)
    }

    fun getStringOrNull(key: String): String? = getString(key)

    fun getBoolean(key: String): Boolean? {
        val value = when (data) {
            is Map<*, *> -> data[key]
            is JsonObject -> data[key]
            else -> null
        }
        return if (value is JsonPrimitive) value.booleanOrNull else (value as? Boolean)
    }

    fun getNumber(key: String): Number? {
        val value = when (data) {
            is Map<*, *> -> data[key]
            is JsonObject -> data[key]
            else -> null
        }
        return if (value is JsonPrimitive) {
            value.longOrNull ?: value.doubleOrNull 
                ?: value.content.toDoubleOrNull()
        } else {
            (value as? Number)
        }
    }

    fun getList(): List<JsonMap?>? {
        val list = when (data) {
            is List<*> -> data
            is JsonArray -> data
            else -> null
        } ?: return null
        return list.map { item ->
            when (item) {
                is Map<*, *> -> JsonMap(item)
                is JsonObject -> JsonMap(item)
                else -> null
            }
        }
    }

    fun getMap(): Map<*, *>? {
        return when (data) {
            is Map<*, *> -> data
            is JsonObject -> data
            else -> null
        }
    }

    fun value(): Any? = data

    fun childrenCount(): Int? {
        return when (data) {
            is List<*> -> data.size
            is Map<*, *> -> data.size
            is JsonArray -> data.size
            is JsonObject -> data.size
            else -> null
        }
    }

    fun keys(): Set<String>? {
        val map = when (data) {
            is Map<*, *> -> data
            is JsonObject -> data
            else -> null
        } ?: return null
        return map.keys.mapNotNull { it?.toString() }.toSet()
    }

}
